import { Box, Chip, styled } from '@mui/material';

export const StyledChatPill = styled(Chip)(({ theme }) => ({}));

export const ChatPillContainer = styled(Box)(({ theme, variant }) => ({
  marginLeft: variant === 'sender' ? 'auto' : '',
  marginBottom: theme.spacing(4),
}));
